import { InlineNotificationType } from '@paragon/notification-tools';

const LOG_OUT_FLASH_KEY = 'logOutFlash';
const LOG_OUT_FLASH_TYPE_KEY = 'logOutFlashType';

export function setLogOutReason(reason: string, type?: InlineNotificationType) {
  window.sessionStorage.setItem(LOG_OUT_FLASH_KEY, reason);

  if (type) {
    window.sessionStorage.setItem(LOG_OUT_FLASH_TYPE_KEY, type);
  }
}

export function getLogOutReason(): [InlineNotificationType | null, string | null] {
  const type = window.sessionStorage.getItem(LOG_OUT_FLASH_TYPE_KEY);
  const reason = window.sessionStorage.getItem(LOG_OUT_FLASH_KEY);

  if (type !== null) window.sessionStorage.removeItem(LOG_OUT_FLASH_TYPE_KEY);
  if (reason !== null) window.sessionStorage.removeItem(LOG_OUT_FLASH_KEY);

  return [type as InlineNotificationType | null, reason];
}
